export default __webpack_public_path__ + "static/media/biodata-4.70e90f56.png";